(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.QProductFormState = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  var forms = new WeakMap();
  function forForm(form) {
    if (forms.has(form)) return forms.get(form);
    var dataset = form.dataset || {};
    var preview = dataset.productPreviewOnly === 'true';
    var blockers = new Map();
    if (preview) blockers.set('preview', 'Vorschau – kein Kauf möglich');
    if (dataset.colorWizardEnabled === 'true') blockers.set('initialization', 'Farbauswahl wird geladen');
    if (dataset.customColorEnabled === 'true') blockers.set('custom-color', 'Farbauswahl wird geladen');
    var select = form.querySelector('[data-product-variant-select]');
    var option = select && select.selectedOptions && select.selectedOptions[0];
    var available = select
      ? !!(option && option.dataset && option.dataset.variantAvailable === 'true')
      : dataset.productAvailable === 'true';
    var busy = false;
    function canSubmit() { return available && !busy && blockers.size === 0; }
    function reconcile() {
      var allowed = canSubmit();
      form.querySelectorAll('[data-product-submit]').forEach(function (button) {
        button.disabled = !allowed;
        button.setAttribute('aria-disabled', String(!allowed));
        button.setAttribute('aria-busy', String(busy));
      });
      form.setAttribute('aria-busy', String(busy));
      return allowed;
    }
    var api = {
      setAvailability: function (value) { available = value === true; return reconcile(); },
      setBusy: function (value) { busy = value === true; return reconcile(); },
      setBlocker: function (owner, reason) {
        if (!owner || (preview && owner === 'preview')) return reconcile();
        if (reason == null) blockers.delete(owner); else blockers.set(owner, String(reason));
        return reconcile();
      },
      canSubmit: canSubmit,
      reconcile: reconcile,
      getStatus: function () { return { available: available, busy: busy, blockers: Object.fromEntries(blockers), canSubmit: canSubmit() }; }
    };
    forms.set(form, api); reconcile(); return api;
  }
  return { forForm: forForm };
});

